export const NOT_SENT_ZAJAVL_STATUS = 1;
export const MODERATION_ZAJAVL_STATUS = 2;
export const RETURN_REWORK_ZAJAVL_STATUS = 3;
export const ACCEPTED_ZAJAVL_STATUS = 4;
export const VUZ_REJECTED_STATUS = 5;
export const APPLICANT_CALL_OFF_STATUS = 6;
export const SEND_CHANGES_AFTER_ACCEPTED = 7;

export const ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS = 21;
export const ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS = 22;

export const ACCEPTED_ZAJAVL_WITH_CONFIRMED_CONSENT_STATUS = 23;
export const ACCEPTED_ZAJAVL_WITH_CONFIRMED_DENIAL_STATUS = 24;
export const ACCEPTED_ZAJAVL_WITH_DROP_CONSENT_STATUS_HIDDEN = 93;
export const ACCEPTED_ZAJAVL_WITH_DROP_DENIAL_STATUS_HIDDEN = 94;

export const VUZ_TAKE_CHANGES_AFTER_ACCEPTED_HIDDEN = 91;
export const VUZ_DROP_CHANGES_AFTER_ACCEPTED_HIDDEN = 92;

// статус-удалено
export const VUZ_DELETE_STATUS = 90;
